import { handleActions } from 'redux-actions';
import AnalyticsModel from '../../models';
import { DAILY } from '../../models/resolution';
import { TAnalytics, TAnalyticsParams, TChart, TResolution } from '../../types';
import { AnalyticsState } from '../../../../../analytics/analyticsTypes';

export interface OverviewState {
  isLoading: boolean;
  analytics: TAnalytics;
  hasError: boolean;
}

export const initialState: OverviewState = {
  isLoading: true,
  analytics: new AnalyticsModel(),
  hasError: false
};

export const FETCH_ANALYTICS_OVERVIEW = 'ANALYTICS_OVERVIEW/FETCH';
export const FETCH_ANALYTICS_OVERVIEW_SUCCESS = 'ANALYTICS_OVERVIEW/SUCCESS';
export const FETCH_ANALYTICS_OVERVIEW_FAILURE = 'ANALYTICS_OVERVIEW/FAILURE';

function setChartDataOnResolutionChange(
  prevAnalytics: TAnalytics,
  analytics: TAnalytics,
  type: TChart
) {
  const engagementGraphs = ['comments', 'replies'];
  const rankGraphs = ['likes', 'dislikes'];

  let newAnalytics = null;
  if (engagementGraphs.includes(type)) {
    newAnalytics = prevAnalytics.set(engagementGraphs[0], analytics.get(engagementGraphs[0]));
    newAnalytics = newAnalytics.set(engagementGraphs[1], analytics.get(engagementGraphs[1]));
  } else if (rankGraphs.includes(type)) {
    newAnalytics = prevAnalytics.set(rankGraphs[0], analytics.get(rankGraphs[0]));
    newAnalytics = newAnalytics.set(rankGraphs[1], analytics.get(rankGraphs[1]));
  } else {
    newAnalytics = prevAnalytics.set(type, analytics.get(type));
  }
  return newAnalytics;
}

export default handleActions<OverviewState, any>(
  {
    [FETCH_ANALYTICS_OVERVIEW]: (state, { payload }) => ({
      ...state,
      isLoading: true
    }),
    [FETCH_ANALYTICS_OVERVIEW_SUCCESS]: (
      state,
      { payload: { analytics, resolution = DAILY, type } }
    ) => {
      let newAnalytics = new AnalyticsModel().parse(analytics);

      if (type) {
        let currAnalytics = new AnalyticsModel().parse(analytics, { type, resolution });
        newAnalytics = setChartDataOnResolutionChange(state.analytics, currAnalytics, type);
      }

      return {
        ...state,
        isLoading: false,
        analytics: newAnalytics
      };
    },
    [FETCH_ANALYTICS_OVERVIEW_FAILURE]: (state, { payload: { error } }) => ({
      ...state,
      isLoading: false,
      hasError: true,
      analytics: new AnalyticsModel()
    })
  },
  initialState
);

export const fetchAnalyticsOverview = ({
  spotId,
  device,
  resolution,
  fromDay,
  toDay,
  type
}: TAnalyticsParams) => ({
  type: FETCH_ANALYTICS_OVERVIEW,
  payload: {
    spotId,
    device,
    resolution,
    from_day: fromDay,
    to_day: toDay,
    type
  },
  meta: {}
});

export const fetchAnalyticsOverviewSuccess = (
  analytics: any,
  resolution: TResolution,
  type: TChart
) => ({
  type: FETCH_ANALYTICS_OVERVIEW_SUCCESS,
  payload: { analytics, resolution, type },
  meta: {}
});

export const fetchAnalyticsOverviewFailure = (error: Error) => ({
  type: FETCH_ANALYTICS_OVERVIEW_FAILURE,
  payload: { error },
  meta: {}
});
